import { render } from "./AccountRelated.vue?vue&type=template&id=229c9f7a&ts=true"
import script from "./AccountRelated.vue?vue&type=script&lang=ts"
export * from "./AccountRelated.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__